// extracted by mini-css-extract-plugin
module.exports = {"tooltip--content":"Tooltip_tooltip--content__D6tvM","tooltip--icon":"Tooltip_tooltip--icon__1Gfdf"};